import { createContext } from 'react';
import type { TalkingPointDto, TopicDto } from '../../api/generated/client';
import type { AdvisoryNeedDto } from '../../interfaces/advisory-need';

export interface INeedContentContextProps {
    activeTalkingPoint?: TalkingPointDto;
    activeAdvisoryNeed?: AdvisoryNeedDto;
    setActiveTalkingPoint: (talkingPoint?: TalkingPointDto) => void;
    setActiveAdvisoryNeed: (advisoryNeed?: AdvisoryNeedDto) => void;
    activeTopic?: TopicDto;
    talkingPoints?: TalkingPointDto[];
    isTalkingPointRefetch: boolean;
    isAdvisoryNeedRefetch: boolean;
}

/**
 * Context for storing the needs content data.
 * @type {Context<INeedContentContextProps | null>}
 */
export const needContentContext = createContext<INeedContentContextProps | null>(null);
